import React from 'react';
export default () => (
  <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M16 1.53333C15.4 1.8 14.8 2 14.1333 2.06667C14.8 1.66667 15.3333 1 15.6 0.266667C14.9333 0.666667 14.2667 0.933333 13.5333 1.06667C12.8667 0.4 12 0 11.0667 0C8.93333 0 7.4 2 7.86667 4C5.13333 3.86667 2.73333 2.6 1.13333 0.6C0.266667 2.06667 0.666667 4 2.13333 5C1.6 4.93333 1.06667 4.8 0.666667 4.6C0.6 6.13333 1.73333 7.53333 3.26667 7.86667C2.8 8 2.26667 8 1.8 7.93333C2.2 9.26667 3.4 10.2 4.86667 10.2C3.46667 11.2667 1.73333 11.7333 0 11.5333C1.46667 12.4667 3.2 13 5 13C11.0667 13 14.5333 7.86667 14.3333 3.26667C15 2.8 15.5333 2.2 16 1.53333Z"
        fill="black"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
